<template>
  <div>
    <!-- done users items  -->
    <div
      class="users-container p-4 pb-2 flex flex-col items-center relative overflow-hidden mb-4"
    >
      <div class="flex items-center w-full">
        <h4
          v-if="
            !doneItemsLoading && doneUsersItems && doneUsersItems.length > 0
          "
          class="mr-2 w-26"
        >
          To Review
        </h4>
        <h4
          v-else-if="
            !doneItemsLoading && doneUsersItems && doneUsersItems.length === 0
          "
          class="mr-2 w-26"
        >
          No pending review found
        </h4>

        <div v-if="doneItemsLoading">
          <vs-avatar
            v-for="i in 6"
            :key="i"
            size="40px"
            class="animate-pulse"
          />
        </div>

        <div
          class="flex items-center w-1"
          v-if="
            !doneItemsLoading && doneUsersItems && doneUsersItems.length > 0
          "
        >
          <div
            v-for="(user, index) in doneUsersItems"
            :key="index"
            @click="setActiveCircle(index)"
          >
            <vx-tooltip
              class="capitalize"
              :text="`${user.userData.firstName} ${user.userData.lastName}`"
            >
              <vs-avatar
                :style="borderStyle('done', true)"
                @click.capture="setActiveCircle(index)"
                :size="index === currentSelectedUserIndex ? '47px' : '40px'"
                class="m-1 w-100 z-10"
                v-if="user.userData.profilePictureUrl"
                :src="`${constants.s3Bucket}/editor/profile-pictures/${user.userData.profilePictureUrl}`"
              />

              <vs-avatar
                :style="borderStyle('done', true)"
                @click.capture="setActiveCircle(index)"
                v-else
                :size="index === currentSelectedUserIndex ? '47px' : '40px'"
                class="m-1"
                :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                  user.userData.firstName || 'boringAvatar',
                  user.userData.lastName || 'boringAvatar'
                )}`"
              />
            </vx-tooltip>
          </div>
        </div>
      </div>

      <div
        class="absolute flex flex-col items-end h-100 next-2 z-10 pr-4 pt-2 pl-0"
      >
        <vx-tooltip class="capitalize" text="Next">
          <img
            v-if="doneUsersItems && doneUsersItems.length"
            class="arrow next right-4 m-1"
            src="@/assets/images/icons/next-arrow.svg"
            alt=""
            @click="handleNext"
          />
        </vx-tooltip>
      </div>

      <div class="w-full flex justify-end">
        <div
          v-if="doneUsersItems && doneUsersItems.length"
          class="flex items-center"
        >
          <vue-circle
            :progress="remainingTimePercentage"
            :key="remainingTimePercentage"
            :size="20"
            :reverse="false"
            line-cap="round"
            :fill="fill"
            empty-fill="rgba(0, 0, 0, .1)"
            :animation-start-value="0.0"
            :start-angle="0"
            insert-mode="append"
            :thickness="4"
            :show-percent="false"
            class="mr-1"
          />
          Next update in approximately {{ formattedRemainingTime }}
        </div>
      </div>
    </div>

    <!-- current active user  -->
    <div
      class="admin__container overflow-hidden"
      v-if="doneUsersItems && currentItem && currentItem.userData"
    >
      <div
        class="relative admin__container__main shadow rounded-lg mb-50 md:mb-2"
      >
        <div class="details__container">
          <div class="details__picture">
            <img
              v-if="currentItem && currentItem.userData.profilePictureUrl"
              class="rounded-circle __img"
              :style="
                borderStyle(
                  currentItem.feedLibraryItemStatus,
                  currentItem.feedItemUserValidationStatus
                )
              "
              :src="`${constants.s3Bucket}/editor/profile-pictures/${currentItem.userData.profilePictureUrl}`"
              alt="Profile Picture"
            />

            <img
              v-else
              class="rounded-circle __img"
              :style="
                borderStyle(
                  currentItem.feedLibraryItemStatus,
                  currentItem.feedItemUserValidationStatus
                )
              "
              :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                currentItem.userData.firstName || 'boringAvatar',
                currentItem.userData.lastName || 'boringAvatar'
              )}`"
              alt="Profile Picture"
            />

            <div
              v-if="!isStatusFetched"
              class="flex items-center justify-center w-full"
            >
              <span class="__role __role__do bg-slate-300">
                <div class="animate-pulse">Loading...</div>
              </span>
            </div>
            <div v-else class="flex items-center justify-center w-full">
              <span
                class="__role __role__do"
                v-if="currentItem.feedLibraryItemStatus === 'notInterested'"
                >Not Interested</span
              >
              <span
                class="__role __role__do"
                v-if="currentItem.feedLibraryItemStatus === 'do'"
                >Not Started</span
              >
              <span
                class="__role __role__doing"
                v-if="currentItem.feedLibraryItemStatus === 'doing'"
                >In progress</span
              >
              <span
                class="__role __role__doing"
                v-if="
                  currentItem.feedLibraryItemStatus === 'done' &&
                  !isUserValidated
                "
                >Awaiting Validation</span
              >
              <span
                class="__role __role__done"
                v-if="
                  currentItem.feedLibraryItemStatus === 'done' &&
                  isUserValidated
                "
                >To Review</span
              >
            </div>
          </div>

          <div class="details__information">
            <div class="main__info">
              <h3>
                {{ currentItem.userData.firstName }}
                {{ currentItem.userData.lastName }}
              </h3>
              <h6>
                {{ currentItem.userData.profession }}
              </h6>
            </div>

            <!-- <div class="skills__info">
              <h6>Skill</h6>

              <div>
                <span>Figma</span>
                <span>Adobe Illustrator </span>
                <span>Office 365</span>
              </div>
            </div> -->

            <div class="contact__info">
              <div class="contact__details">
                <img
                  src="@/assets/images/icons/org-review/iconEmail.svg"
                  alt="email"
                />

                <div>
                  {{ currentItem.userData.email }}
                </div>
              </div>

              <!-- <div class="contact__details">
                <img
                  :src="
                    require(`@/assets/images/icons/org-review/iconPhone.svg`)
                  "
                  alt="phone"
                />

                <a>+12 345 6789 0</a>
              </div> -->
            </div>
          </div>
        </div>

        <div class="treasury__container">
          <h3>Wallet</h3>
          <h4>
            {{ xp }}
            XP
          </h4>
          <div class="treasury__information">
            <div class="treasury__information__1">
              <!-- <h6>Pending Validation</h6>
              <h5>40 XP</h5> -->
            </div>

            <div class="treasury__information__2">
              <!-- <h6>Successful Distributions</h6>
              <h5>6000 XP</h5> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- current assignment -->
    <!-- item to review  -->
    <!-- Skeleton  -->
    <div v-if="doneItemsLoading">
      <div
        v-for="i in 2"
        :key="i"
        class="border border-blue-300 shadow rounded-lg p-4 w-full animate-pulse h-48 my-6"
        style="background: #8080805e"
      ></div>
    </div>
    <vx-card
      v-if="currentItem && currentItem.feedLibraryItem && !doneItemsLoading"
      class="my-4"
    >
      <vs-row class="flex-col md:flex-row"
        ><vs-col class="md:w-1/3 lg:w-1/6">
          <div class="overflow-hidden rounded-lg assignment__img">
            <img
              class="h-full w-full object-cover"
              :src="
                currentItem.feedLibraryItem &&
                currentItem.feedLibraryItem.imageUrl
                  ? currentItem.feedLibraryItem.imageUrl
                  : randomFeedImage
              "
              :alt="currentItem.feedLibraryItem.title"
              @error="randomFeedImage"
            /></div></vs-col
        ><vs-col
          class="md:w-2/3 lg:w-5/6 md:pl-8 flex flex-col justify-between"
        >
          <div>
            <div
              class="flex items-center mt-2 lg:mt-0"
              v-if="currentItem && currentItem.assignedFromGtbrddUserId"
            >
              <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
                <img
                  class="w-full h-full object-cover rounded-full"
                  :src="
                    userProfilePic
                      ? constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        userProfilePic
                      : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                          userName,
                          userName
                        )}`
                  "
                />
              </div>
              <div class="font-semibold text-lg text-black">
                Assigned By {{ userName }}
                <!-- {{
                  getAssignedUser(
                    currentItem.assignedFromGtbrddUserId
                  )
                }} -->
              </div>
            </div>
            <div
              class="flex items-center mt-2 lg:mt-0"
              v-else-if="currentItem.feedLibraryItem.assignedBy.type === 'user'"
            >
              <div class="h-8 w-8 overflow-none mr-2" v-if="userName !== 'you'">
                <img
                  class="w-full h-full object-cover rounded-full"
                  :src="
                    userProfilePic
                      ? constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        userProfilePic
                      : `https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                          userName,
                          userName
                        )}`
                  "
                />
              </div>
              <div class="font-semibold text-lg text-black">
                Assigned By {{ userName }}
              </div>
            </div>
            <div v-else></div>

            <div class="flex items-center">
              <div
                class="text-black text-2xl truncate grow mt-2 lg:mt-0"
                v-if="
                  currentItem.feedLibraryItem &&
                  currentItem.feedLibraryItem.title
                "
              >
                {{ currentItem.feedLibraryItem.title }}
              </div>

              <img
                @click.once="openLink(currentItem.feedLibraryItem)"
                class="ml-3 mt-2 lg:mt-0 cursor-pointer"
                src="@/assets/images/icons/arrow-right-circle.svg"
                alt="right-arrow"
              />
            </div>

            <div
              class="text-lg gray-400 my-3"
              v-if="
                currentItem.feedLibraryItem &&
                currentItem.feedLibraryItem.description &&
                typeof currentItem.feedLibraryItem.description === 'string'
              "
            >
              {{ currentItem.feedLibraryItem.description }}
            </div>

            <div
              class="text-lg gray-400 my-3"
              v-else-if="currentItem.feedLibraryItem.description.length > 0"
            >
              <div
                v-for="(data, index) in currentItem.feedLibraryItem.description"
                :key="index"
                v-html="data"
              ></div>
            </div>
          </div>

          <!-- 
          <div
            v-if="
              reviewAssignment.users &&
              currentItem &&
              currentItem
                .feedLibraryItemStatus === 'done' &&
              currentItem &&
              currentItem.libraryItemValidationData.validationType ===
                'upload'
            "
            class="flex items-center justify-end"
          >
            <div
              class="button__decline px-3 py-2 mr-3 flex items-center"
              @click="
                validateAssignment(
                  'DECLINED',
                  currentItem.userData,
                  currentItem,
                  currentItem
                    .feedLibraryItemStatus
                )
              "
            >
              <img
                class="mr-2"
                src="@/assets/images/icons/org-review/cross.svg"
                alt=""
              />
              Decline
            </div>
            <div
              class="button__accept px-3 py-2 flex items-center"
              @click="
                validateAssignment(
                  'ACCEPTED',
                  currentItem.userData,
                  reviewAssignment,
                  currentItem
                    .feedLibraryItemStatus
                )
              "
            >
              <img
                class="mr-2"
                src="@/assets/images/icons/org-review/tick.svg"
                alt=""
              />

              Accept
            </div>
          </div> -->

          <!-- <div
            v-else-if="
              currentItem
                .feedLibraryItemStatus === 'do' ||
              currentItem
                .feedLibraryItemStatus === 'doing'
            "
            class="flex items-center py-3 px-2"
          >
            <span>
              <img src="@/assets/images/icons/alert-circle.svg" alt="" />
            </span>
            <h5 class="ml-2 text-left" style="color: #ff6e4f !important">
              It appears that the item has not been marked as 'done'. Therefore,
              the item cannot be reviewed at this time.
            </h5>
          </div> -->
        </vs-col></vs-row
      >

      <div
        v-if="currentItem && currentItem.feedLibraryItemStatus === 'do'"
        class="flex items-center py-3 px-2 item-notice--do mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This item is assigned to
          {{ currentItem.userData.firstName }}
          {{ currentItem.userData.lastName }}
          by <b>admin </b>and is in <b>'Not Started'</b> state.
        </h5>
      </div>

      <div
        v-if="
          currentItem &&
          currentItem.feedLibraryItemStatus === 'done' &&
          !isUserValidated &&
          currentItem.libraryItemValidationData &&
          currentItem.libraryItemValidationData.validationType
        "
        class="flex items-center py-3 px-2 item-notice--doing mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This learning action is marked 'Done'. A review will be queued for
          approval as soon as its validation is completed.
        </h5>
      </div>

      <div
        v-if="
          currentItem &&
          currentItem.feedLibraryItemStatus === 'done' &&
          !isUserValidated &&
          !currentItem.libraryItemValidationData
        "
        class="flex items-center py-3 px-2 item-notice--doing mt-2 md:mt-5"
      >
        <h5 class="ml-2 text-left">
          This learning action is marked 'Done'. Add a Validation to confirm the
          learning to release learning experience points and possible rewards.
        </h5>
      </div>
      <!-- qr scan -->
      <div
        v-if="
          currentItem &&
          currentItem.feedLibraryItemStatus === 'done' &&
          currentItem.libraryItemValidationData.validationType ===
            'attendance' &&
          isUserValidated
        "
      >
        <div class="py-10 px-4 my-4 md:my-10 action__container">
          <div class="flex items-center justify-center">
            <img
              style="filter: drop-shadow(10px 10px 30px rgba(0, 16, 97, 0.2))"
              src="@/assets/images/icons/qr-code-dummy.svg"
              alt="QR Code"
            />
          </div>

          <div class="action__container__remarks">
            <div class="text-center font-bold text-xl text-black">QR Code</div>
            <div class="text-center text-lg" style="color: #787878">
              QR Code scan time: {{ scanTime }}
            </div>
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center justify-between">
          <div class="text-lg md:text-left" style="color: #787878">
            A validation is submitted on this learning. You may review and
            release the learning experience to be claimed.
          </div>
          <!-- btns  -->
          <div class="action__container__buttons mt-4 md:mt-0">
            <button
              class="decline__button px-3 py-2"
              @click="
                validateAssignment(
                  'DECLINED',
                  currentItem.userData,
                  currentItem.feedLibraryItem,
                  currentItem.feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/cross.svg" />Decline
            </button>

            <button
              class="approve__button px-3 py-2"
              @click="
                validateAssignment(
                  'ACCEPTED',
                  currentItem.userData,
                  currentItem.feedLibraryItem,
                  currentItem.feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/tick.svg" />Accept
            </button>
          </div>
        </div>
      </div>

      <!-- quiz -->
      <div
        v-if="
          quizResultData &&
          quizResultData.quizPercent &&
          quizResultData.numOfCorrectQuestions >= 0 &&
          quizResultData.totalNumOfQuestions &&
          isUserValidated
        "
      >
        <div class="py-10 px-4 mt-16 mb-8 action__container">
          <div class="action__container__badges">
            <img
              v-if="quizResultData.quizPercent <= 50"
              class="bad__badge"
              src="@/assets/images/icons/org-review/org-review-bad.svg"
            />

            <img
              v-else-if="
                quizResultData.quizPercent > 50 &&
                quizResultData.quizPercent <= 75
              "
              class="avg__badge"
              src="@/assets/images/icons/org-review/org-review-avg.svg"
            />

            <img
              v-else-if="quizResultData.quizPercent >= 75"
              class="good__badge"
              src="@/assets/images/icons/org-review/org-review-good.svg"
            />
          </div>

          <div class="action__container__remarks">
            <h3>Test Completed!</h3>

            <p v-if="quizResultData.quizPercent <= 50" class="bad__remark">
              That’s poor.
              {{ currentItem.userData.firstName }}
              {{ currentItem.userData.lastName }}
              only got <br /><span
                >{{ quizResultData.numOfCorrectQuestions }}/{{
                  quizResultData.totalNumOfQuestions
                }}</span
              >
              answers correct.
            </p>
            <p
              v-else-if="
                quizResultData.quizPercent > 50 &&
                quizResultData.quizPercent < 75
              "
              class="avg__remark"
            >
              That’s fair.
              {{ currentItem.userData.firstName }}
              {{ currentItem.userData.lastName }}
              got a<br /><span
                >{{ quizResultData.numOfCorrectQuestions }}/{{
                  quizResultData.totalNumOfQuestions
                }}</span
              >
              answers correct.
            </p>
            <p
              v-else-if="quizResultData.quizPercent >= 75"
              class="good__remark"
            >
              That’s great.
              {{ currentItem.userData.firstName }}
              {{ currentItem.userData.lastName }}
              got a<br /><span
                >{{ quizResultData.numOfCorrectQuestions }}/{{
                  quizResultData.totalNumOfQuestions
                }}</span
              >
              answers correct.
            </p>
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center justify-between">
          <div class="text-lg md:text-left" style="color: #787878">
            A validation is submitted on this learning. You may review and
            release the learning experience to be claimed.
          </div>
          <!-- btns  -->
          <div class="action__container__buttons">
            <button
              class="decline__button px-3 py-2"
              @click="
                validateAssignment(
                  'DECLINED',
                  currentItem.userData,
                  currentItem.feedLibraryItem,
                  currentItem.feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/cross.svg" />Decline
            </button>

            <button
              class="approve__button px-3 py-2"
              @click="
                validateAssignment(
                  'ACCEPTED',
                  currentItem.userData,
                  currentItem.feedLibraryItem,
                  currentItem.feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/tick.svg" />Accept
            </button>
          </div>
        </div>
      </div>

      <!-- upload -->
      <div
        v-if="
          currentItem &&
          currentItem.feedLibraryItemStatus === 'done' &&
          currentItem.libraryItemValidationData.validationType === 'upload' &&
          isUserValidated
        "
      >
        <div
          class="py-10 px-4 mt-16 mb-8 action__container flex justify-center items-center"
        >
          <div class="w-1/2 h-1/2">
            <img
              class="w-full h-full object-cover"
              :src="documentUploaded"
              alt=""
            />
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center justify-between">
          <div class="text-lg md:text-left" style="color: #787878">
            A validation is submitted on this learning. You may review and
            release the learning experience to be claimed.
          </div>
          <!-- btns  -->
          <div class="action__container__buttons">
            <button
              class="decline__button px-3 py-2"
              @click="
                validateAssignment(
                  'DECLINED',
                  currentItem.userData,
                  currentItem.feedLibraryItem,
                  currentItem.feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/cross.svg" />Decline
            </button>

            <button
              class="approve__button px-3 py-2"
              @click="
                validateAssignment(
                  'ACCEPTED',
                  currentItem.userData,
                  currentItem.feedLibraryItem,
                  currentItem.feedLibraryItemStatus
                )
              "
            >
              <img src="@/assets/images/icons/org-review/tick.svg" />Accept
            </button>
          </div>
        </div>
      </div>
    </vx-card>

    <div
      v-else-if="
        doneUsersItems && doneUsersItems.length === 0 && !doneItemsLoading
      "
      class="flex items-center justify-center"
    >
      <div
        class="no-assignments flex flex-col items-center justify-center lg:w-3/4"
      >
        <img
          src="@/assets/images/icons/org-review/empty.svg"
          width="250px"
          height="250px"
        />
        <h4>
          Check back later! It's possible that new assignments will become
          available for review at a later time. You could check back
          periodically to see if any new assignments have been posted.
        </h4>
      </div>
    </div>

    <!-- load more btn -->
    <vs-row
      v-if="
        !moreAssignmentLoading &&
        moreUserAssignments.length !== 0 &&
        !moreUserItem
      "
      class="flex justify-center mt-6"
    >
      <button
        class="loadmore-btn cursor-pointer py-3 px-6"
        @click="loadMoreItems"
      >
        Load more items for
        {{ currentItem.userData.firstName }}

        {{
          currentItem.userData && currentItem.userData.lastName
            ? currentItem.userData.lastName
            : ""
        }}
      </button>
    </vs-row>

    <!-- other item of current user  -->
    <div v-if="moreAssignmentLoading" id="moreItems">
      <div
        v-for="i in 5"
        :key="i"
        class="border border-blue-300 shadow rounded-lg p-4 w-full animate-pulse h-48 my-6"
        style="background: #8080805e"
      ></div>
    </div>
    <div v-else-if="moreUserItem && !moreAssignmentLoading">
      <div
        v-if="moreUserAssignments && moreUserAssignments.length > 0"
        class="mt-6"
      >
        <h4 class="text-2xl font-semibold text-black">
          Other items of
          {{ currentItem.userData.firstName }}

          {{
            currentItem.userData && currentItem.userData.lastName
              ? currentItem.userData.lastName
              : ""
          }}
        </h4>
        <extra-task-card
          v-for="assignment in moreUserAssignments"
          :key="assignment.itemId"
          :assignment="assignment"
          :orgId="orgId"
          class="my-4"
          v-show="
            currentItem.feedLibraryItem.itemId !==
            assignment.feedLibraryItem.itemId
          "
          @acceptedAssignment="acceptedAssignment"
        />
      </div>

      <div
        v-else-if="moreUserAssignments && moreUserAssignments.length === 0"
        class="flex items-center justify-center"
      >
        <div class="no-assignments flex flex-col items-center justify-center">
          <img
            src="@/assets/images/icons/org-review/empty.svg"
            width="250px"
            height="250px"
          />
          <h4>
            Check back later! It's possible that new assignments will become
            available at a later time.
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reviewMixin from "../reviewMixin";
import ExtraTaskCard from "../components/ExtraTaskCard.vue";
import VueCircle from "vue2-circle-progress";

export default {
  data() {
    return {
      currentSelectedUserIndex: null,
      moreUserAssignments: [],
      moreAssignmentLoading: false,
      moreUserItem: false,
      xp: 0,
      scanTime: "",
      isUserValidated: false,
      documentUploaded: "",
      userName: "",
      userProfilePic: "",
      quizResultData: {},
      remainingUpdateTime: 0,
      fill: { gradient: ["#0DDBB3", "#0DDBB3"] },
      currentItem: {},
      isStatusFetched: false,
    };
  },
  components: {
    VueCircle,
    ExtraTaskCard,
  },
  mixins: [reviewMixin],
  computed: {
    loggedUserData() {
      return this.$store.state.users.data;
    },
    formattedRemainingTime() {
      if (this.remainingUpdateTime <= 0) {
        return "";
      }

      let remainingHours = Math.floor(
        this.remainingUpdateTime / (60 * 60 * 1000)
      );
      let remainingMinutes = Math.floor(
        (this.remainingUpdateTime % (60 * 60 * 1000)) / (60 * 1000)
      );
      let remainingSeconds = Math.floor(
        (this.remainingUpdateTime % (60 * 1000)) / 1000
      );

      return `${remainingHours > 0 ? remainingHours : ""}${
        remainingHours > 0 ? "hr:" : ""
      }
      ${remainingMinutes > 0 ? remainingMinutes : ""}${
        remainingMinutes > 0 ? "mins:" : ""
      }
${remainingSeconds}s`;
    },
    remainingTimePercentage() {
      if (this.remainingUpdateTime <= 0) {
        return 0;
      }
      let totalTime = 3 * 60 * 60 * 1000;
      let percentage =
        ((totalTime - this.remainingUpdateTime) / totalTime) * 100;
      return parseInt((100 - percentage).toFixed(2)); // Round to 2 decimal places
    },
  },
  watch: {
    doneUsersItems: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          if (this.$route.query && this.$route.query.userId) {
            let index = newVal.findIndex(
              (user) => user.userData._id === this.$route.query.userId
            );
            if (index > -1) {
              this.currentSelectedUserIndex = index;
              this.setActiveCircle(this.currentSelectedUserIndex);
            } else {
              this.currentSelectedUserIndex = 0;
              this.setActiveCircle(this.currentSelectedUserIndex);
            }
            this.loadUserItems(this.$route.query.userId);
          } else {
            this.currentSelectedUserIndex = 0;
            this.setActiveCircle(this.currentSelectedUserIndex);
          }
          this.loadUserItems(newVal[0].userData._id);
          this.getToken(newVal[0].userData.aggregatedWallet);
        }
      },
    },
    currentSelectedUserIndex(newVal) {
      if (this.doneUsersItems[newVal] && this.doneUsersItems[newVal].userData) {
        this.isStatusFetched = false;
        this.loadUserItems(this.doneUsersItems[newVal].userData._id);
        this.getToken(this.doneUsersItems[newVal].userData.aggregatedWallet);
        this.moreUserItem = false;
        this.isUserValidated = false;
      }
    },
  },
  mounted() {
    this.getNextUpdateTime();
  },
  methods: {
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    setActiveCircle(index) {
      this.currentSelectedUserIndex = index;
    },
    handleNext() {
      if (this.currentSelectedUserIndex < this.doneUsersItems.length - 1) {
        this.currentSelectedUserIndex++;
      }
    },
    getToken(tokens) {
      if (tokens && tokens.length > 0) {
        for (let i = 0; i < tokens.length; i++) {
          if (tokens[i].tokenKey === 0) {
            this.xp = tokens[i].tokenValueSum;
          } else if (tokens[i].tokenKey === 2) {
            this.gold = tokens[i].tokenValueSum;
          }
        }
      }
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.orgId
      }&redirectsourceid=ORG_REVIEW`;
      this.routeToLink = true;
      if (link && this.routeToLink) {
        window.open(link, "_blank");
        this.routeToLink = false;
      }
    },
    validateAssignment(status, currentUser, item, completionStatus) {
      event.stopPropagation();
      if (completionStatus === "do" || completionStatus === "doing") {
        this.$vs.notify({
          color: "warning",
          text: "It appears that the item has not been marked as 'done' by the user yet. Therefore, the item cannot be reviewed at this time.",
        });
        this.handleNext();
      } else {
        this.routeToLink = false;
        const payload = {
          libraryItemIds: [item.itemId],
          reviewStatus: status,
          gtbrddOrganizationId: this.orgId,
          gtbrddUserId: currentUser._id,
          xpValue: this.currentItem.xpValue,
        };
        this.$store
          .dispatch("alex/reviewAssignment", payload)
          .then((res) => {
            if (res) {
              this.doneUsersItems.splice(this.currentSelectedUserIndex, 1);
              if (this.currentSelectedUserIndex >= this.doneUsersItems.length) {
                this.currentSelectedUserIndex = 0;
              }
            }
          })
          .catch((err) => {
            //  console.log(err);
          });
      }
    },
    loadUserItems(id) {
      const payload = {
        orgId: this.orgData._id,
        userId: id,
      };
      this.$store
        .dispatch("alex/getUserItems", payload)
        .then((res) => {
          if (res && res.data.length > 0) {
            let assignments = res.data.sort(
              (a, b) =>
                b.feedItemUserValidationStatus - a.feedItemUserValidationStatus
            );
            this.currentItem = assignments[0];
            this.getAssignedUser(assignments[0].assignedFromGtbrddUserId);
            this.moreUserAssignments = assignments.slice(1);
            this.getQrScanTime();
            this.getDocument();
            this.getQuizResult();
          }
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    loadMoreItems() {
      // this.doneUsersItems = this.doneUsersItems.splice(
      //   this.currentSelectedUserIndex,
      //   1
      // );
      const loadElement = setInterval(function () {
        this.moreAssignmentLoading = true;

        let elementPosition = document
          .getElementById("moreItems")
          .getBoundingClientRect().top;
        let headerOffset = 150;
        let offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }, 100);
      setTimeout(() => {
        this.moreAssignmentLoading = false;
        clearInterval(loadElement);
      }, 1000);
      this.moreUserItem = true;
    },
    getAssignedUser(id) {
      this.$store
        .dispatch("users/getAssignedUser", id)
        .then((res) => {
          this.userProfilePic = res.profilePictureUrl
            ? res.profilePictureUrl
            : "";
          if (
            res.firstName === this.loggedUserData.firstName &&
            res.lastName === this.loggedUserData.lastName
          ) {
            this.userName = "you";
          } else {
            this.userName = `${res.firstName} ${
              res.lastName ? res.lastName : ""
            }`;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getQuizResult() {
      if (
        this.currentItem &&
        this.currentItem.feedLibraryItem &&
        this.currentItem.libraryItemValidationData.validationType === "quiz"
      ) {
        const payload = {
          orgId: this.orgId,
          userId:
            this.currentItem && this.currentItem.userData
              ? this.currentItem.userData._id
              : "",
          itemId: this.currentItem.feedLibraryItem.itemId,
        };
        this.$store
          .dispatch("organization/fetchQuizResult", payload)
          .then((res) => {
            if (res && res.data) {
              if (res.data.quizComplete) {
                const quizPercent = (
                  (res.data.numOfCorrectQuestions /
                    res.data.totalNumOfQuestions) *
                  100
                ).toFixed(2);

                this.isUserValidated = true;

                this.quizResultData = {
                  quizPercent: quizPercent,
                  numOfCorrectQuestions: res.data.numOfCorrectQuestions,
                  totalNumOfQuestions: res.data.totalNumOfQuestions,
                };
              }
            }
          })
          .catch((err) => {
            // console.log(err);
          })
          .finally(() => {
            this.isStatusFetched = true;
          });
      }
    },
    getQrScanTime() {
      if (
        this.currentItem &&
        this.currentItem.libraryItemValidationData.validationType ===
          "attendance"
      ) {
        this.scanTime = "";
        this.$store
          .dispatch("users/getAttendance", {
            organizationId: this.orgId,
            feedItemId: this.currentItem.feedLibraryItem.itemId,
            userId: this.currentItem.userData._id,
          })
          .then((res) => {
            if (res && res.data && res.data.validated_at) {
              const timestamp = new Date(res.data.validated_at);
              const userTimeZone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;

              const options = {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                timeZone: userTimeZone,
              };
              const formattedDate = timestamp.toLocaleDateString(
                "en-US",
                options
              );
              this.scanTime = formattedDate;
              this.isUserValidated = true;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.isStatusFetched = true;
          });
      }
    },
    getDocument() {
      if (
        this.currentItem &&
        this.currentItem.libraryItemValidationData.validationType === "upload"
      ) {
        const payload = {
          orgId: this.orgId,
          userId:
            this.currentItem && this.currentItem.userData
              ? this.currentItem.userData._id
              : "",
          itemId: this.currentItem.feedLibraryItem.itemId,
        };
        this.$store
          .dispatch("organization/fetchUploadedDocument", payload)
          .then((res) => {
            if (res && res.data && res.data.s3FilePath) {
              this.isUserValidated = true;
              this.documentUploaded = res.data.s3FilePath;
            }
          })
          .catch((err) => {
            // console.log(err);
          })
          .finally(() => {
            this.isStatusFetched = true;
          });
      }
    },
    getNextUpdateTime() {
      const currentDateTime = new Date();
      const currentISOString = currentDateTime.toISOString();
      const currentDateString = currentISOString.split("T")[0];
      const currentHour = parseInt(
        currentISOString.split("T")[1].slice(0, -5).split(":")[0],
        10
      );
      const roundedHour = Math.ceil(currentHour / 3) * 3;
      const nextOccurrenceString = `${currentDateString}T${roundedHour
        .toString()
        .padStart(2, "0")}:00:00.000Z`;

      let nextOccurrence = new Date(nextOccurrenceString);

      if (nextOccurrence - currentDateTime <= 0) {
        nextOccurrence = new Date(
          nextOccurrence.getTime() + 3 * 60 * 60 * 1000
        );
      }

      // Calculate the remaining time until the next occurrence
      let remainingTime = nextOccurrence - new Date();
      this.remainingUpdateTime = remainingTime;
      setInterval(() => {
        this.remainingUpdateTime -= 1000; // Subtract 1 second
      }, 1000);
    },
    acceptedAssignment(val) {
      let itemIndex = this.moreUserAssignments.findIndex(
        (item) => item.itemId === val.itemId
      );
      if (itemIndex > -1) {
       this.moreUserAssignments.splice(itemIndex, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../reviewBase.scss";

.loadmore-btn {
  border-radius: 10px;
  color: #212020;
  font-weight: 600;
  font-size: 1.25em;
  background-color: #cbd5e0ae !important;
  border: none;
  &--light {
    background-color: #cbd5e077 !important;
  }
}

.item-notice {
  &--do {
    background: #f044380a;
    border: 2px solid #f044381a;
    border-radius: 0.5rem;
    h5 {
      color: #f04438 !important;
    }
  }
  &--doing {
    background: #f293000f;
    border: 2px solid #f293001a;
    border-radius: 0.5rem;
    h5 {
      color: #f29300 !important;
    }
  }
}

.action__container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  border: 2px solid #eaecf0;
  border-radius: 0.75rem;
  gap: 2rem;

  &__badges {
    width: fit-content;
    place-self: center;

    img {
      width: 8rem;
      height: auto;
    }

    .good__badge {
      width: 10rem;
      height: auto;
    }
  }

  &__remarks {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: fit-content;
    place-self: center;

    h3 {
      color: #000;
      text-align: center;
      font-size: 1.25rem;
      font-weight: 700;
    }

    p {
      color: #787878;
      text-align: center;
      font-size: 1rem;
      font-weight: 400;

      span {
        font-size: 1rem;
        font-weight: 700;
      }
    }

    .bad__remark {
      span {
        color: #fb2e56;
      }
    }

    .avg__remark {
      span {
        color: #f36f0f;
      }
    }

    .good__remark {
      span {
        color: #12b76a;
      }
    }
  }

  &__buttons {
    width: fit-content;
    place-self: center;
    gap: 2rem;
    display: flex;
    flex-direction: row;

    button {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 1.25rem;
      gap: 0.8rem;
      color: #fff;
      text-align: center;
      font-weight: 600;

      img {
        height: auto;
      }
    }

    .decline__button {
      background-color: #fb2e56;
      border: none;
      cursor: pointer;
    }

    .approve__button {
      background-color: #12b76a;
      border: none;
      cursor: pointer;
    }
  }
}
</style>
